import * as React from 'react';
import { bool } from 'prop-types';
import { extend, QueryProvider } from '@thd-nucleus/data-sources';
import { ThankYou } from './ThankYou';

export const ThankYouContainer = () => {
  return (
    <QueryProvider cacheKey="thank-you">
      <ThankYou />
    </QueryProvider>
  );
};

ThankYouContainer.displayName = 'ThankYouContainer';

ThankYouContainer.dataModel = extend(ThankYou);
